__turbopack_context__.v({
  "body": "style-module-scss-module__GJz_5W__body",
  "number": "style-module-scss-module__GJz_5W__number",
  "placements": "style-module-scss-module__GJz_5W__placements",
  "price": "style-module-scss-module__GJz_5W__price",
  "prices": "style-module-scss-module__GJz_5W__prices",
  "slider": "style-module-scss-module__GJz_5W__slider",
});
